import { render } from "./GroupCreator.vue?vue&type=template&id=18150775&scoped=true"
import script from "./GroupCreator.vue?vue&type=script&lang=js"
export * from "./GroupCreator.vue?vue&type=script&lang=js"

import "./GroupCreator.vue?vue&type=style&index=0&id=18150775&scoped=true&lang=css"

import exportComponent from "../../../venturestar-data-emails-sentistar/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18150775"]])

export default __exports__